<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import SidenavItem from "./SidenavItem.vue";
// --- IMPORTAMOS LAS FUNCIONES DE SEGURIDAD ---
import { tieneAcceso, seccionVisible } from "../../utils/roles"; 

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

// --- CONTROL DEL MENÚ ACORDEÓN ---
const menuAbierto = ref('activos');

const toggleMenu = (menu) => {
  menuAbierto.value = menuAbierto.value === menu ? '' : menu;
};
</script>

<template>
  <div class="navbar-collapse w-auto" id="sidenav-collapse-main">
    <ul class="navbar-nav">

      <li class="nav-item" v-if="tieneAcceso('dashboard-default')">
        <sidenav-item to="/dashboard-default" :class="getRoute() === 'dashboard-default' ? 'active' : ''" navText="Inicio">
          <template v-slot:icon>
            <i class="fas fa-home text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li v-if="seccionVisible('activos_fijos')" class="mt-4 nav-item mb-1 header-menu" @click="toggleMenu('activos')">
        <div class="d-flex justify-content-between align-items-center pe-4 cursor-pointer">
          <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2 mb-0">Activos Fijos</h6>
          <i class="fas text-secondary text-xs transition-icon" :class="menuAbierto === 'activos' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
      </li>

      <div v-if="seccionVisible('activos_fijos')" v-show="menuAbierto === 'activos'" class="submenu-container">
        <li class="nav-item" v-if="tieneAcceso('gestion-activos')">
          <sidenav-item to="/gestion-activos" :class="getRoute() === 'gestion-activos' ? 'active' : ''" navText="Gestión de Activos">
            <template v-slot:icon><i class="fas fa-boxes text-info text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('nuevos-activos')">
          <sidenav-item to="/nuevos-activos" :class="getRoute() === 'nuevos-activos' ? 'active' : ''" navText="Registro de Activos">
            <template v-slot:icon><i class="fas fa-plus-square text-success text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('asignar-activos')">
          <sidenav-item to="/asignar-activos" :class="getRoute() === 'asignar-activos' ? 'active' : ''" navText="Asignación de Activos">
            <template v-slot:icon><i class="fas fa-handshake text-warning text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('transferencias')">
          <sidenav-item to="/transferencias" :class="getRoute() === 'transferencias' ? 'active' : ''" navText="Transferencias">
            <template v-slot:icon><i class="fas fa-exchange-alt text-primary text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('gestion_bajas')">
          <sidenav-item to="/gestion-bajas" :class="getRoute() === 'gestion-bajas' ? 'active' : ''" navText="Gestión de Baja">
            <template v-slot:icon><i class="fas fa-trash-alt text-danger text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('reportes')">
          <sidenav-item to="/reportes" :class="getRoute() === 'reportes' ? 'active' : ''" navText="Reportes y Estadísticas">
            <template v-slot:icon><i class="fas fa-chart-pie text-dark text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('monitoreo')">
          <sidenav-item to="/monitoreo" :class="getRoute() === 'monitoreo' ? 'active' : ''" navText="Monitoreo por Regional">
            <template v-slot:icon><i class="fas fa-map-marked-alt text-info text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('panel-administrativo')">
          <sidenav-item to="/panel-administrativo" :class="getRoute() === 'panel-administrativo' ? 'active' : ''" navText="Panel Administrativo">
            <template v-slot:icon><i class="fas fa-cogs text-dark text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('misactivos')">
          <sidenav-item to="/misactivos" :class="getRoute() === 'misactivos' ? 'active' : ''" navText="Mis Activos">
            <template v-slot:icon><i class="fas fa-laptop text-primary text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
      </div>

      <li v-if="seccionVisible('soporte')" class="mt-4 nav-item mb-1 header-menu" @click="toggleMenu('soporte')">
        <div class="d-flex justify-content-between align-items-center pe-4 cursor-pointer">
          <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2 mb-0">Soporte Técnico</h6>
          <i class="fas text-secondary text-xs transition-icon" :class="menuAbierto === 'soporte' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
      </li>

      <div v-if="seccionVisible('soporte')" v-show="menuAbierto === 'soporte'" class="submenu-container">
        <li class="nav-item" v-if="tieneAcceso('solicitud-usuario')">
          <sidenav-item to="/solicitud-usuario" :class="getRoute() === 'solicitud-usuario' ? 'active' : ''" navText="Solicitar Servicio">
            <template v-slot:icon><i class="fas fa-tools text-warning text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('gestion-tickets')">
          <sidenav-item to="/gestion-tickets" :class="getRoute() === 'gestion-tickets' ? 'active' : ''" navText="Gestion Tickets">
            <template v-slot:icon><i class="fas fa-tools text-warning text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('Historial')">

          <sidenav-item to="/Historial" :class="getRoute() === 'Historial' ? 'active' : ''" navText="Historial Técnico">
            <template v-slot:icon><i class="fas fa-history text-info text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
      </div>

      <li v-if="seccionVisible('ia')" class="mt-4 nav-item mb-1 header-menu" @click="toggleMenu('ia')">
        <div class="d-flex justify-content-between align-items-center pe-4 cursor-pointer">
          <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2 mb-0">Analítica Predictiva (IA)</h6>
          <i class="fas text-secondary text-xs transition-icon" :class="menuAbierto === 'ia' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
      </li>

      <div v-if="seccionVisible('ia')" v-show="menuAbierto === 'ia'" class="submenu-container">
        <li class="nav-item" v-if="tieneAcceso('modulo-predictivo')">
          <sidenav-item to="/modulo-predictivo" :class="getRoute() === 'modulo-predictivo' ? 'active' : ''" navText="Pronóstico de Fallas">
            <template v-slot:icon><i class="fas fa-brain text-primary text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('configuracion-difusa')">
          <sidenav-item to="/configuracion-difusa" :class="getRoute() === 'configuracion-difusa' ? 'active' : ''" navText="Configuración Difusa">
            <template v-slot:icon><i class="fas fa-sliders-h text-dark text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
      </div>

      <li v-if="seccionVisible('usuarios')" class="mt-4 nav-item mb-1 header-menu" @click="toggleMenu('usuarios')">
        <div class="d-flex justify-content-between align-items-center pe-4 cursor-pointer">
          <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2 mb-0">Usuarios y Perfil</h6>
          <i class="fas text-secondary text-xs transition-icon" :class="menuAbierto === 'usuarios' ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </div>
      </li>

      <div v-if="seccionVisible('usuarios')" v-show="menuAbierto === 'usuarios'" class="submenu-container">
        <li class="nav-item" v-if="tieneAcceso('profile')">
          <sidenav-item to="/profile" :class="getRoute() === 'profile' ? 'active' : ''" navText="Mi Perfil">
            <template v-slot:icon><i class="fas fa-user-circle text-primary text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('crear-usuarios')">
          <sidenav-item to="/crear-usuarios" :class="getRoute() === 'crear-usuarios' ? 'active' : ''" navText="Crear Usuarios">
            <template v-slot:icon><i class="fas fa-user-plus text-success text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('Personal')">
          <sidenav-item to="/Personal" :class="getRoute() === 'Personal' ? 'active' : ''" navText="Directorio de Personal">
            <template v-slot:icon><i class="fas fa-users-cog text-warning text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
        <li class="nav-item" v-if="tieneAcceso('solicitud-acceso')">
          <sidenav-item to="/solicitud-acceso" :class="getRoute() === 'solicitud-acceso' ? 'active' : ''" navText="Solicitudes de Acceso">
            <template v-slot:icon><i class="fas fa-user-clock text-warning text-sm opacity-10"></i></template>
          </sidenav-item>
        </li>
      </div>

    </ul>
  </div>
</template>

<style>
/* El mismo CSS que tenías, no hace falta cambiarlo */
.sidenav { overflow: hidden !important; }
#sidenav-collapse-main { overflow-y: auto !important; overflow-x: hidden !important; height: calc(100vh - 120px) !important; scrollbar-width: none !important; -ms-overflow-style: none !important; }
#sidenav-collapse-main::-webkit-scrollbar { display: none !important; width: 0 !important; background: transparent !important; }
.navbar-vertical .navbar-collapse:after { display: none !important; }
.sidenav-footer { display: none !important; }
.navbar-nav { padding-bottom: 40px !important; }
.cursor-pointer { cursor: pointer; }
.header-menu:hover h6 { color: #5e72e4 !important; opacity: 1 !important; }
.header-menu:hover .transition-icon { color: #5e72e4 !important; }
.submenu-container { padding-left: 0.8rem; transition: all 0.3s ease-in-out; }
</style>